module.exports = __webpack_public_path__ + "static/media/blog3.f814e8bd.webp";